import React from 'react';
import {
  FiShoppingCart,
  FiCoffee,
  FiUsers,
  FiHelpCircle,
} from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../../../assets/elegantelogo.png';

const Sidebar = ({ activeMenu, setActiveMenu }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const menuItems = [
    { 
      name: 'Cashier', 
      icon: <FiShoppingCart />, 
      path: '/restaurant/LoungeCashierDashboard' 
    },
    { 
      name: 'End of Day', 
      icon: <FiCoffee />, 
      path: '/cashier/LoungeEOD'  // Correct path from App.jsx
    },
    { 
      name: 'Sales', 
      icon: <FiUsers />, 
      path: '/cashier/LoungeSalesSummary' 
    },
  ];

  const getActiveMenu = () => {
    const currentPath = location.pathname;
    const activeItem = menuItems.find(item => currentPath === item.path);
    return activeItem ? activeItem.name : null;
  };

  const activeMenuItem = getActiveMenu();

  const handleMenuClick = (item) => {
    setActiveMenu(item.name);
    navigate(item.path);  // Use navigate instead of window.location
  };

  return (
    <aside className="epos-sidebar">
      <div className="epos-brand">
        <div className="brand-logo-full">
          <img src={logo} alt="Elegante Restaurant Logo" />
        </div>
      </div>

      <div className="menu-list">
       <div className="menu-section-label">🍸 Lounge</div>

        {menuItems.map((item) => (
          <button
            key={item.name}
            className={`menu-btn ${(activeMenu === item.name || activeMenuItem === item.name) ? 'active' : ''}`}
            onClick={() => handleMenuClick(item)}
          >
            <span className="menu-icon">{item.icon}</span>
            <span className="menu-text">{item.name}</span>
          </button>
        ))}

        <hr className="menu-divider" />

        <div className="menu-section-label" style={{ marginTop: 4 }}>
          Support
        </div>
        <button className="menu-btn" style={{ opacity: 0.7 }}>
          <span className="menu-icon">
            <FiHelpCircle />
          </span>
          <span className="menu-text">Help</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;